import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { forwardRef as D } from "react";
import { c as r } from "./index.CWkFp9WS.js";
import { O as c } from "./ODSRow.Du_e7gfN.js";
import { O as p } from "./ODSText.D6mgyggF.js";
import { O as d } from "./ODSIcon.DjL6Q3o4.js";
import '../assets/ODSPickerDropdownItem.css';const k = D(({ className: s, label: o, selected: m = !1, disabled: a = !1, ...i }, t) => /* @__PURE__ */ n(
  c,
  {
    ref: t,
    className: r("ODSPickerDropdownItem", s),
    role: "menuitem",
    ...i,
    children: [
      o && /* @__PURE__ */ e(
        p,
        {
          as: "span",
          className: r("ODSPickerDropdownItem-Label", {
            "ODSPickerDropdownItem-Label--disabled": a
          }),
          children: o
        }
      ),
      /* @__PURE__ */ e(c, { className: "ODSPickerDropdownItem-IconContainer", children: m && /* @__PURE__ */ e(
        d,
        {
          name: "checkmark-type-bold",
          className: r(
            "ODSPickerDropdownItem-Checkmark",
            { "ODSPickerDropdownItem-Checkmark--selected": m },
            { "ODSPickerDropdownItem-Checkmark--disabled": a }
          )
        }
      ) })
    ]
  }
));
k.displayName = "ODSPickerDropdownItem";
export {
  k as O
};
//# sourceMappingURL=ODSPickerDropdownItem.nw-WS9Ve.js.map
